import { H1 } from '@betterment/samba-react';

import { ApplicationLayout } from '../layout/ApplicationLayout';

export const HomePage = () => {
  return (
    <ApplicationLayout pageTitle="Reports">
      <ApplicationLayout.Header>
        <H1 variant="pageTitle">Dashboard home</H1>
      </ApplicationLayout.Header>
      <ApplicationLayout.Content />
      <ApplicationLayout.Footer />
    </ApplicationLayout>
  );
};
